import React from 'react';
import { Badge } from 'react-bootstrap';

const STATUS_VARIANTS = {
  PENDING: 'warning',
  ASSIGNED: 'info',
  CONFIRMED: 'info',
  PICKED_UP: 'primary',
  IN_TRANSIT: 'info',
  OUT_FOR_DELIVERY: 'primary',
  DELIVERED: 'success',
  CANCELLED: 'danger',
};

const DeliveryStatusBadge = ({ status }) => (
  <Badge bg={STATUS_VARIANTS[status] || 'secondary'}>{status}</Badge>
);

export default DeliveryStatusBadge;
